import React, { useState } from 'react'
import { Route, Routes } from 'react-router'
import { AlertProvider } from './ghospital/context/AlertContext';
import { useAuth } from './ghospital/context/AuthContext'

import AdminRoutes from './ghospital/routes/AdminRoutes'
import AuthRoutes from './ghospital/routes/AuthRoutes'
import { SocketProvider } from './ghospital/context/SocketContext';
import ManagerRoutes from './ghospital/routes/ManagerRoutes';
import LogoutPage from './ghospital/app/auth/pages/LogoutPage';

function App() {
    const {isLoggedIn,authUser} = useAuth();
    return (
        <>
        <AlertProvider>
            {isLoggedIn ? 
                <SocketProvider>
                    { authUser.role == 1 &&
                        <AdminRoutes/>
                    }
                    { authUser.role == 2 &&
                        <ManagerRoutes />
                    }
                    <Routes>
                        <Route path="/auth/logout" element={<LogoutPage/>}></Route>
                    </Routes>
                </SocketProvider>
                :
                <AuthRoutes/>
            }
        </AlertProvider>
        </>
    )
}
export default App